// extracted by mini-css-extract-plugin
module.exports = {"slider":"style_slider__1O4_O"};